export const enum NegotiationProposalUserType {
  SELLER = 'SELLER',
  TOP_BIDDER = 'TOP_BIDDER',
  SECOND_BIDDER = 'SECOND_BIDDER'
}

export const enum NegotiationActionType {
  PROPOSAL = 'PROPOSAL',
  TIMER_EXPIRED = 'TIMER_EXPIRED',
  DECLINED = 'DECLINED',
  ACCEPTED = 'ACCEPTED',
  FINAL_ASKING_PRICE = 'FINAL_ASKING_PRICE'
}

class NegotiationProposal {
  id: number;

  price: number;

  comment: string;

  userSeller: boolean;

  userId: number;

  dealerId: number;

  time: string;

  stayFirm: boolean;

  fullName: string;

  userInitials: string;

  recipient?: NegotiationProposalUserType;

  initiator?: NegotiationProposalUserType;

  actionType?: NegotiationActionType;

  isUserSeller: boolean;

  constructor({
    id,
    price,
    comment,
    userSeller,
    userId,
    dealerId,
    time,
    stayFirm,
    fullName,
    userInitials,
    recipient,
    initiator,
    actionType,
    isUserSeller
  }) {
    this.id = id || null;
    this.price = price;
    this.comment = comment;
    this.userSeller = userSeller;
    this.userId = userId;
    this.dealerId = dealerId;
    this.time = time;
    this.stayFirm = stayFirm;
    this.fullName = fullName;
    this.userInitials = userInitials;
    this.recipient = recipient;
    this.initiator = initiator;
    this.actionType = actionType;
    this.isUserSeller = isUserSeller;
  }
}

export default NegotiationProposal;
